import { IgnoredProjectKeysTuple, SidePanelLayerType } from "@nova/constants"
import { Project } from "@nova/protobuf"

export type EntityType = keyof Omit<Project, IgnoredProjectKeysTuple>
export const sidePanelLayerTypeByProtobufEntityType: Record<EntityType, SidePanelLayerType> = {
    icons: SidePanelLayerType.Icon,
    lines: SidePanelLayerType.Line,
    rulers: SidePanelLayerType.Ruler,
    texts: SidePanelLayerType.Text,
    perimeters: SidePanelLayerType.FirePerimeter,
    PDFRasters: SidePanelLayerType.PDFRaster,
    infraredFlights: SidePanelLayerType.HotspotFlight,
    orthoFlights: SidePanelLayerType.OrthomosaicFlight,
    videoFlights: SidePanelLayerType.VideoFlight,
    videoColorFinderFlights: SidePanelLayerType.VideoColorFinder,
    imageColorFinderFlights: SidePanelLayerType.ImageColorFinder,
    panoramaFlights: SidePanelLayerType.Panorama,
    groups: SidePanelLayerType.Group,
    liveVideoFlights: SidePanelLayerType.LiveVideoFlight,
    mergedFlights: SidePanelLayerType.MergedFlight,
    mapComments: SidePanelLayerType.Comment,
    satelliteFlights: SidePanelLayerType.SatelliteFlight,
    userLocationShares: SidePanelLayerType.UserLocationShare,
}
